// import Product from './../asset/svg/MainMenu/'
//@ts-ignore
import Product from './../asset/svg/MainMenu/Product.svg';
//@ts-ignore
import ProductActiveImg from './../asset/svg/MainMenu/ActiveProduct.svg';
//@ts-ignore
import BaseOptions from './../asset/svg/MainMenu/BaseOption.svg';
//@ts-ignore
import BaseOptionsActiveImg from './../asset/svg/MainMenu/ActiveBaseOption.svg';
//@ts-ignore
import Sides from './../asset/svg/MainMenu/Sides.svg';
//@ts-ignore
import ActiveSides from './../asset/svg/MainMenu/ActiveSides.svg';
//@ts-ignore
import Upgrades from './../asset/svg/MainMenu/Upgrades.svg';
//@ts-ignore
import ActiveUpgrades from './../asset/svg/MainMenu/ActiveUpgrades.svg';
//@ts-ignore
import Colors from './../asset/svg/MainMenu/Colors.svg';
//@ts-ignore
import ActiveColors from './../asset/svg/MainMenu/ActiveColors.svg'

// //@ts-ignore
// const Product = require('./../asset/svg/MainMenu/Product.svg');
// //@ts-ignore
// const ProductActiveImg = require('./../asset/svg/MainMenu/ActiveProduct.svg');
// //@ts-ignore
// const BaseOptions = require('./../asset/svg/MainMenu/BaseOption.svg');
// //@ts-ignore
// const BaseOptionsActiveImg = require('./../asset/svg/MainMenu/ActiveBaseOption.svg');
// //@ts-ignore
// const Sides = require('./../asset/svg/MainMenu/Sides.svg');
// //@ts-ignore
// const ActiveSides = require('./../asset/svg/MainMenu/ActiveSides.svg');
// //@ts-ignore
// const Upgrades = require('./../asset/svg/MainMenu/Upgrades.svg');
// //@ts-ignore
// const ActiveUpgrades = require('./../asset/svg/MainMenu/ActiveUpgrades.svg');
// //@ts-ignore
// const Colors = require('./../asset/svg/MainMenu/Colors.svg');
// //@ts-ignore
// const ActiveColors = require('./../asset/svg/MainMenu/ActiveColors.svg');


export type itemMenu = {
    key: string;
    imgUrl: string;
    imgUrlActive: string;
    name: string;
}

export let listGlobalMenu: itemMenu[] = [
    {
        key: 'Product',
        imgUrl: Product,
        imgUrlActive: ProductActiveImg,
        name: 'Product',
    },
    {
        key: 'BaseOptions',
        imgUrl: BaseOptions,
        imgUrlActive: BaseOptionsActiveImg,
        name: 'Base Options',
    },
    {
        key: 'Sides',
        imgUrl: Sides,
        imgUrlActive: ActiveSides,
        name: 'Sides',
    },
    {
        key: 'Upgrades',
        imgUrl: Upgrades,
        imgUrlActive: ActiveUpgrades,
        name: 'Upgrades',
    },
    {
        key: 'Colors',
        imgUrl: Colors,
        imgUrlActive: ActiveColors,
        name: 'Colors',
    },
]